document.addEventListener('DOMContentLoaded', function() {


    // Get our lazy-loaded images
    var lazyImages = [].slice.call(
        document.querySelectorAll("img.img-lazy-load")
    );

    if ("IntersectionObserver" in window) {
        // Create new observer object
        let lazyImageObserver = new IntersectionObserver(function(
            entries,
            observer
        ) {
            // Loop through IntersectionObserverEntry objects
            entries.forEach(function(entry) {
                // Do these if the target intersects with the root
                if (entry.isIntersecting) {
                    // console.log('intersecting')
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("img-lazy-load");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        // Loop through and observe each image
        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }








    function loadScriptById(src, id, type, async = true) {
        var isIdExist = document.getElementById(id);
        if (isIdExist) {
            console.log('element with id=' + id + ' already exist');
        } else {
            var thridPartyScript = document.createElement("script");
            thridPartyScript.type = type;
            thridPartyScript.setAttribute("async", async);
            thridPartyScript.setAttribute("src", src);
            thridPartyScript.id = id;
            document.body.appendChild(thridPartyScript);
            console.log("appended " + thridPartyScript.id + " script successfully");
        }
    }


    //loadScriptById("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6321061981120130", "adsense-ad-tag", "text/javascript");
    



    //STICKY HEADER MENU
    const mainMenu = document.querySelector('.main-menu');
    if (!mainMenu) return;
    const triggerOffset = window.innerHeight * 0.10;

    function updateSticky() {
        if (window.scrollY >= triggerOffset) {
            mainMenu.classList.add('sticky');
        } else {
            mainMenu.classList.remove('sticky');
        }
    }
    window.addEventListener('scroll', updateSticky);
    updateSticky();


    //AUTHOR TABS
    const tabLinks = document.querySelectorAll('.author-tabs-nav .tab-link');
    const tabPanels = document.querySelectorAll('.author-tabs-content .tab-panel');

    function activateTab(targetId) {

        tabLinks.forEach(link => link.classList.remove('active'));
        tabPanels.forEach(panel => panel.classList.remove('active'));
        const clickedTab = document.querySelector(`a[href="${targetId}"]`);
        const targetPanel = document.querySelector(targetId);
        if (clickedTab && targetPanel) {
            clickedTab.classList.add('active');
            targetPanel.classList.add('active');
        }
    }
    tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            activateTab(targetId);
        });
    });
    if (window.location.hash) {
        activateTab(window.location.hash);
    }
});

document.querySelectorAll('a[href="#"]').forEach(link =>
    link.addEventListener('click', e => e.preventDefault())
);






document.addEventListener('DOMContentLoaded', function() {
    const toggler = document.querySelector('.sidebar-toggler');
    const toggler2 = document.querySelector('.sidebar-toggler-2');
    const offcanvas = document.querySelector('.offcanvas-container');

    const searchToggle = document.querySelector('.search-toggle a');
    const closeSearch=document.querySelector('.close-search');

    searchToggle.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.search-container').style.display='block';
    })

    closeSearch.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.search-container').style.display='none';
    })
    



    function toggleOffcanvas() {
        offcanvas.classList.toggle('active');
        document.body.classList.toggle('offcanvas-open');
    }

    toggler.addEventListener('click', toggleOffcanvas);
    toggler2.addEventListener('click', toggleOffcanvas);

    offcanvas.addEventListener('click', function(e) {
        if (e.target === offcanvas || e.target.closest('.close-offcanvas')) {
            offcanvas.classList.remove('active');
            document.body.classList.remove('offcanvas-open');
        }
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && offcanvas.classList.contains('active')) {
            offcanvas.classList.remove('active');
            document.body.classList.remove('offcanvas-open');
        }
    });
});